import FeesCard from "./FeesCard";

export default function Class7() {
  return (
    <FeesCard
        badge="Class 7"
        title="💰 Class 7 Tuition Details"
        className="7th Standard"
        fee="₹1,200"
        days="Monday – Saturday"
        time="4:30 PM – 7:30 PM"
        subjects={[
          "English",
          "Mathematics",
          "Science",
          "Social Science"
        ]}
        approach={[
          "Exam preparation",
          "Doubt-solving sessions",
          "Performance tracking"
        ]}
        note="₹500 extra for evening snacks / milk.
        Self pickup & drop only."
      />
  );
}